import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { PureButton } from '../../basics';
import { ButtonType } from '../../enums';
import { TypeaheadActionType } from '../../reducer';
import styles from './SuggestionList.module.scss';
const SuggestionList = ({ dispatch, onSuggestionClick, poweredByImage, selectedIndex, suggestions, }) => {
    const handleMouseEnter = (hoveredSuggestion) => {
        dispatch({
            type: TypeaheadActionType.Suggestions,
            suggestions: suggestions.map(suggestion => ({
                ...suggestion,
                highlighted: suggestion.id === hoveredSuggestion.id,
            })),
        });
    };
    const handleMouseLeave = () => {
        dispatch({
            type: TypeaheadActionType.Suggestions,
            suggestions: suggestions.map((suggestion, index) => ({
                ...suggestion,
                highlighted: index === selectedIndex,
            })),
        });
    };
    const list = suggestions.map((suggestion, index) => {
        return (_jsx("li", { className: "w-100", children: _jsxs(PureButton, { onClick: () => onSuggestionClick(suggestion), onMouseEnter: () => handleMouseEnter(suggestion), onMouseLeave: handleMouseLeave, className: classNames('w-100 p-1-5x', {
                    [styles.suggestionEntrySelected]: selectedIndex === index,
                    [styles.suggestionEntry]: selectedIndex !== index,
                }), type: ButtonType.Button, tabIndex: index, children: [_jsx("span", { className: "fw-semibold mr-0-5x", children: suggestion.title }), suggestion.subTitle && (_jsx("span", { className: styles.subtitle, children: suggestion.subTitle }))] }) }, suggestion.id));
    });
    return (_jsxs("div", { className: classNames(styles.listHolder, 'mt-1x position-absolute'), children: [_jsx("ul", { className: classNames('d-flex flex-column p-0', styles.unStyledList), "data-testid": "suggestion-list", children: list }), poweredByImage && (_jsx("img", { src: poweredByImage, className: classNames('d-block position-absolute', styles.powerByImage), alt: "powered by label" }))] }));
};
export { SuggestionList };
